import { useQuery } from "@tanstack/react-query";
import { getInventory } from "../../api/inventory.api";
import { inventoryKeys } from "../../queryKeys";

export const useInventory = (productId: string) => {
  return useQuery({
    queryKey: [...inventoryKeys.all, productId],
    queryFn: () => getInventory(productId),
    enabled: !!productId,
    select: (res) => {
      if (res?.message?.toLowerCase() === "success" && res?.data?.data) {
        return res.data.data.quantity;
      }
      return 0;
    },
    staleTime: 1000 * 30 * 30 // 30 minutes
  });
};
